import React from "react";
import PartyCreateForm from "./PartyCreateForm";

export default function SellerForm() {
  return <PartyCreateForm type="seller" />;
}
